<template>
  <div id="myitem">
    <!-- ...你的其他模板代码... -->
    
    <!-- 使用 留言板 组件 -->
    <messages></messages>
  </div>
</template>

<script>
// 导入 留言板 组件
import messages from "../components/MessagesCpt.vue";

export default {
	data() {
		return {};
	},
	components: {
		// 注册 留言板 组件
		messages,
	},
	methods: {},
};
</script>

<style scoped>
/* ...你的样式... */
</style>
